var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoifinitywhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 153,
    viewBox: "0 0 300 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.4163 85.2346C57.5979 85.2346 47.6539 94.5329 47.6539 109.514C47.6539 124.365 57.7271 133.147 70.6414 133.147C82.3935 133.147 94.1455 125.656 94.1455 108.739C94.1455 94.7912 85.1055 85.2346 71.4163 85.2346ZM71.0288 124.752C64.0551 124.752 59.6642 118.037 59.6642 109.255C59.6642 101.636 63.0219 93.6289 71.158 93.6289C79.0357 93.6289 82.2643 101.894 82.2643 109.126C82.2643 118.424 77.6152 124.752 71.0288 124.752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.772 86.2678H98.1489V132.114H109.772V86.2678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.845 132.114V94.9204H113.646V86.2678H119.845V84.0723C119.845 71.6746 128.368 64.1843 142.058 64.1843C146.707 64.1843 152.131 65.3466 154.843 67.1546L152.26 75.9363C150.194 74.774 146.449 73.4826 142.187 73.4826C134.18 73.4826 131.597 78.39 131.597 84.4598V86.3969H158.975V132.243H147.353V94.9204H131.726V132.114H119.845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.333 99.957C162.333 94.6621 162.204 90.2712 161.946 86.2678H172.019L172.536 93.1124H172.794C174.86 89.4963 179.897 85.2346 187.516 85.2346C195.523 85.2346 203.788 90.4004 203.788 104.994V132.243H192.165V106.285C192.165 99.6987 189.712 94.6621 183.384 94.6621C178.734 94.6621 175.506 98.0198 174.344 101.507C173.956 102.411 173.827 103.831 173.827 105.123V132.114H162.204V99.957H162.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.769 86.2678H207.146V132.114H218.769V86.2678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.819 74.5157V86.2678H250.796V94.9204H239.819V115.196C239.819 120.878 241.369 123.719 245.76 123.719C247.826 123.719 248.988 123.59 250.28 123.203L250.409 131.985C248.73 132.63 245.631 133.147 242.015 133.147C237.624 133.147 234.137 131.726 232.071 129.402C229.488 126.819 228.455 122.557 228.455 116.487V94.9204H221.997V86.2678H228.455V77.7443L239.819 74.5157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.939 86.2678L275.204 110.934C276.108 113.775 277.142 117.262 277.787 119.845H278.046C278.691 117.262 279.595 113.775 280.499 110.934L287.602 86.3969H300L288.506 117.52C282.178 134.697 277.916 142.316 272.622 146.965C267.972 150.969 263.323 152.389 260.482 152.777L257.899 143.091C259.836 142.574 262.29 141.541 264.615 139.862C266.81 138.442 269.393 135.73 271.072 132.63C271.588 131.726 271.718 131.081 271.718 130.564C271.718 130.047 271.588 129.402 271.201 128.239L254.283 86.1386H266.939V86.2678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5441 99.053C30.3487 104.348 28.2824 109.901 26.2161 115.325C24.7955 109.514 23.1167 103.702 21.1795 97.5033L12.656 68.5751H0L20.9212 132.114H32.6733C36.031 120.62 40.551 109.514 44.9419 98.7947C45.7167 96.9867 46.4916 95.1787 47.2665 93.2415C51.1408 84.5889 55.9191 76.0655 61.4722 68.3169H47.9122C47.9122 68.446 47.783 68.446 47.783 68.5751C43.7796 74.9032 40.4219 81.4895 37.1933 88.3341C35.5144 91.821 34.0938 95.437 32.5441 99.053Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.957 79.1649C216.524 79.1649 219.415 76.2739 219.415 72.7077C219.415 69.1415 216.524 66.2505 212.957 66.2505C209.391 66.2505 206.5 69.1415 206.5 72.7077C206.5 76.2739 209.391 79.1649 212.957 79.1649Z",
    fill: "url(#paint0_linear_12_172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.477 69.35C217.477 70.8997 215.411 72.062 212.957 72.062C210.504 72.062 208.437 70.7706 208.437 69.35C208.437 67.8003 210.504 66.638 212.957 66.638C215.411 66.5088 217.477 67.8003 217.477 69.35Z",
    fill: "url(#paint1_linear_12_172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.057 76.9694C216.057 78.0026 214.636 78.9066 212.828 78.9066C211.02 78.9066 209.6 78.0026 209.6 76.9694C209.6 75.9363 211.02 75.0323 212.828 75.0323C214.636 75.0323 216.057 75.9363 216.057 76.9694Z",
    fill: "url(#paint2_linear_12_172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.288 72.7077C110.288 76.3237 107.447 79.1649 103.831 79.1649C100.215 79.1649 97.3741 76.3237 97.3741 72.7077C97.3741 69.0917 100.215 66.2505 103.831 66.2505C107.447 66.2505 110.288 69.2208 110.288 72.7077Z",
    fill: "url(#paint3_linear_12_172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.351 69.35C108.351 70.8997 106.285 72.062 103.831 72.062C101.378 72.062 99.3112 70.7706 99.3112 69.35C99.3112 67.8003 101.378 66.638 103.831 66.638C106.414 66.5088 108.351 67.8003 108.351 69.35Z",
    fill: "url(#paint4_linear_12_172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.06 76.9694C107.06 78.0026 105.639 78.9066 103.831 78.9066C102.023 78.9066 100.603 78.0026 100.603 76.9694C100.603 75.9363 102.023 75.0323 103.831 75.0323C105.639 75.0323 107.06 75.9363 107.06 76.9694Z",
    fill: "url(#paint5_linear_12_172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.418 79.1649C110.159 79.1649 110.03 79.1649 109.901 79.1649C110.03 79.0357 110.288 78.9066 110.676 78.7774C111.709 78.2609 113.388 77.3569 114.808 75.4197C116.875 72.8368 118.683 68.7043 120.878 63.4094C121.395 62.3762 121.782 61.2139 122.299 59.9225C124.882 53.9819 128.885 45.071 137.15 37.0641C144.77 29.3155 158.071 24.1498 171.89 23.6332C173.827 23.5041 175.764 23.5041 177.701 23.5041C190.228 23.5041 201.076 26.087 209.083 31.1235C220.964 38.2264 223.805 49.4619 224.451 53.9819C226.388 68.1877 222.514 76.8403 221.739 77.3569C221.481 77.3569 221.61 75.5489 221.61 73.7408C221.739 69.7374 221.997 63.1511 220.06 54.6276C218.511 48.5579 214.765 40.2927 205.596 35.127C198.881 31.1235 189.066 28.9281 178.089 28.9281C176.152 28.9281 174.344 28.9281 172.406 29.0573C147.094 29.3155 133.534 46.7499 126.56 61.2139L125.915 62.3762C122.686 68.3168 119.974 73.4826 116.616 76.4529C113.904 78.9066 111.192 79.1649 110.418 79.1649Z",
    fill: "url(#paint6_linear_12_172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.83 23.1167V23.6332C190.357 23.6332 201.205 26.2161 209.083 31.2527C220.835 38.3556 223.676 49.4619 224.451 53.9819C226.13 66.638 223.16 75.0323 221.997 76.8403C221.868 76.1946 221.997 74.9032 221.997 73.7409C222.127 69.7374 222.385 63.022 220.448 54.6276C218.898 48.5579 215.153 40.1636 205.854 34.9979C199.01 30.9944 189.195 28.799 178.218 28.799C176.281 28.799 174.473 28.799 172.536 28.9281C147.094 29.1864 133.405 46.7499 126.56 61.214L125.915 62.3762C122.686 68.3168 119.974 73.3534 116.616 76.3237C114.034 78.5192 111.709 78.9066 110.805 79.0357C111.838 78.5192 113.517 77.6152 115.067 75.5489C117.133 72.966 118.941 68.7043 121.136 63.4094C121.653 62.2471 122.04 61.214 122.557 59.9225C125.14 53.9819 129.143 45.071 137.279 37.1933C144.899 29.4447 158.201 24.4081 171.89 23.7624C173.827 23.6332 175.764 23.6332 177.701 23.6332V23.1167M177.83 23.1167C175.893 23.1167 173.956 23.1167 172.019 23.2458C158.33 23.8915 144.899 28.9281 137.15 36.8059C129.143 44.5545 125.269 52.9488 122.17 59.7934C119.199 66.638 117.133 72.062 114.679 75.1614C112.226 78.2609 109.514 78.6483 109.643 79.294C109.643 79.4232 109.901 79.4232 110.418 79.4232C111.709 79.4232 114.163 78.9066 116.746 76.582C120.362 73.3534 123.203 67.8003 126.819 61.3431C132.888 48.5579 146.061 29.5738 172.406 29.3156C174.344 29.1864 176.152 29.1864 178.089 29.1864C188.42 29.1864 198.364 31.1236 205.467 35.3853C214.12 40.1636 218.252 48.0413 219.802 54.7568C222.901 68.446 220.448 77.486 221.739 77.6152C222.256 77.6152 226.647 68.9626 224.709 53.9819C223.547 46.7499 219.415 37.0642 209.212 30.8653C200.689 25.4412 189.453 23.1167 177.83 23.1167Z",
    fill: "url(#paint7_linear_12_172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.868 77.2277C221.868 77.2277 221.739 77.0986 221.739 76.7112C221.739 75.2906 221.868 73.6117 221.739 71.6746C221.868 67.8003 221.739 61.7305 220.06 54.4985C218.511 48.4288 214.765 40.1636 205.596 34.9979C198.881 30.9944 189.066 28.799 178.089 28.799C176.152 28.799 174.344 28.799 172.406 28.9281C147.094 29.1864 133.534 46.6208 126.56 61.0848L125.915 62.2471C122.686 68.1877 119.974 73.3534 116.616 76.3237L116.487 76.4529C117.908 73.9992 119.328 70.6414 121.007 66.8963C121.524 65.8631 121.911 64.7008 122.428 63.5385C125.011 57.5979 129.014 48.6871 137.279 40.6802C144.899 32.9316 158.201 27.7658 172.019 27.2493C173.956 27.1201 175.893 27.1201 177.83 27.1201C190.357 27.1201 201.205 29.703 209.212 34.7396C221.093 41.8425 223.935 53.0779 224.58 57.5979C224.839 59.406 224.968 61.3431 225.097 63.1511C224.839 71.9329 222.385 76.8403 221.868 77.2277Z",
    fill: "url(#paint8_linear_12_172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.83 27.3784C190.357 27.3784 201.205 29.9613 209.083 34.9978C220.835 42.1007 223.676 53.2071 224.451 57.7271C224.709 59.5351 224.839 61.4722 224.968 63.2802C224.709 70.7706 222.901 75.4197 222.127 76.8403C222.127 75.4197 222.256 73.7409 222.127 71.8037C222.256 67.9294 222.127 61.8597 220.448 54.6276C218.898 48.5579 215.153 40.1636 205.854 34.9978C199.01 30.9944 189.195 28.799 178.218 28.799C176.281 28.799 174.473 28.799 172.536 28.9281C147.094 29.1864 133.405 46.7499 126.56 61.214L125.915 62.3762C122.944 67.8003 120.491 72.5786 117.52 75.5489C118.683 73.2243 119.974 70.3831 121.266 67.1545C121.782 66.1214 122.17 64.9591 122.686 63.7968C125.269 57.8562 129.272 48.9453 137.409 41.0676C145.028 33.319 158.33 28.2824 172.019 27.6367C173.956 27.3784 175.893 27.3784 177.83 27.3784ZM177.83 26.8618C175.893 26.8618 173.956 26.8618 172.019 26.991C158.33 27.6367 144.899 32.6733 137.15 40.551C129.143 48.2996 125.269 56.8231 122.17 63.5385C119.587 69.4791 117.779 74.2574 115.712 77.486C116.1 77.2277 116.487 76.9694 116.875 76.582C120.491 73.3534 123.332 67.8003 126.948 61.3431C133.018 48.5579 146.19 29.5738 172.536 29.3155C174.473 29.1864 176.281 29.1864 178.218 29.1864C188.549 29.1864 198.493 31.1235 205.596 35.3853C214.249 40.1636 218.381 48.0413 219.931 54.7568C221.61 61.9888 221.61 67.8003 221.61 71.8037C221.61 73.7409 221.61 75.4197 221.61 76.8403C221.61 77.2277 221.739 77.486 221.997 77.6152C222.385 77.6152 225.097 72.4494 225.355 63.4094C225.226 61.6014 225.097 59.7934 224.839 57.8562C223.676 50.6242 219.544 40.9384 209.341 34.7396C200.689 29.1864 189.453 26.8618 177.83 26.8618Z",
    fill: "url(#paint9_radial_12_172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.888 79.4232C205.338 79.0357 192.811 73.7409 182.609 57.5979C178.476 51.3991 175.506 43.6505 172.277 35.5144C171.244 32.8024 170.082 29.9613 168.92 27.1201C164.27 13.8183 152.906 5.81146 138.7 5.81146C138.442 5.81146 138.054 5.81146 137.796 5.81146C136.892 5.81146 135.859 5.68231 134.955 5.68231C120.62 5.81146 107.318 11.6229 100.215 21.1795C94.0164 29.0573 90.5295 39.0013 90.1421 50.6242C89.8838 63.7968 94.2746 72.4494 96.3409 76.582C96.8575 77.6152 97.3741 78.5192 97.3741 78.7775C96.3409 78.2609 86.526 68.9626 85.622 50.6242C85.2346 38.2264 88.4632 27.3784 95.1786 18.3384C102.669 7.49032 118.554 0.12915 134.826 0.12915C135.988 0.12915 137.021 0.12915 138.183 0.258294C147.869 0.387437 156.909 3.22859 162.721 7.87775C169.307 13.0435 172.277 19.6298 174.731 25.4412C176.152 29.0573 177.314 32.6733 178.605 36.031C181.317 43.6505 183.642 50.3659 186.87 55.9191C193.198 67.4128 201.076 74.1283 204.821 77.3569C205.725 78.2609 206.758 79.1649 206.888 79.4232Z",
    fill: "url(#paint10_linear_12_172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.697 0.38743C135.859 0.38743 136.892 0.38743 138.054 0.516573C147.74 0.645717 156.651 3.48687 162.462 8.13603C168.92 13.3018 172.019 19.8881 174.344 25.5704C175.764 29.3155 177.056 32.8024 178.218 36.1601C180.93 43.7796 183.254 50.4951 186.483 56.1774C192.811 67.8003 200.689 74.3866 204.563 77.6152C205.209 78.1317 205.725 78.6483 206.113 79.0357C202.884 77.7443 191.778 71.8037 182.738 57.5979C178.605 51.3991 175.635 43.6505 172.406 35.5144C171.373 32.8024 170.211 29.9613 169.049 27.1201C164.399 13.6892 153.035 5.68231 138.571 5.68231C138.313 5.68231 137.925 5.68231 137.667 5.68231C136.763 5.68231 135.73 5.55316 134.826 5.55316C120.362 5.55316 107.06 11.4938 99.8278 21.0504C93.4998 28.9281 90.1421 38.8722 89.7546 50.6242C89.4963 63.7968 93.8872 72.4494 95.9535 76.7112C96.2118 77.2277 96.4701 77.8734 96.7284 78.2609C94.4038 76.3237 86.3969 67.1545 85.622 50.7533C85.2346 38.3556 88.4632 27.5075 95.0495 18.5966C102.669 7.7486 118.554 0.38743 134.697 0.38743ZM134.697 0C118.037 0 102.152 7.61946 94.9204 18.3384C86.6552 29.4447 85.1055 41.3259 85.3638 50.7533C86.2678 69.6083 96.5992 79.1649 97.3741 79.1649C98.5364 78.6483 89.8838 68.9626 90.2712 50.7533C90.5295 41.9716 92.7249 30.9944 100.215 21.4378C107.189 12.1395 120.232 5.94059 134.955 5.94059C135.859 5.94059 136.892 5.94059 137.796 6.06974C138.054 6.06974 138.442 6.06974 138.7 6.06974C154.843 6.06974 164.658 15.8846 168.661 27.2492C173.31 38.4847 176.926 49.4619 182.35 57.8562C192.682 74.1283 205.854 79.6814 207.017 79.6814H207.146C208.179 78.7775 195.91 72.4494 187 55.9191C182.35 47.783 179.509 37.3224 174.989 25.4412C172.536 19.6298 169.436 13.0435 162.979 7.87774C156.522 2.71201 147.094 0.258287 138.313 0.129143C137.021 0 135.859 0 134.697 0Z",
    fill: "url(#paint11_linear_12_172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3706 74.5157C90.4003 70.3831 86.2678 62.6345 85.622 50.8825C86.0095 40.2927 89.2381 30.9944 95.0495 23.1167C102.54 12.2686 118.424 4.90744 134.697 4.90744C135.859 4.90744 136.892 4.90744 138.054 5.03658C147.74 5.16573 156.78 8.00688 162.591 12.656C169.178 17.8218 172.148 24.4081 174.602 30.2195C176.022 33.8356 177.314 37.4516 178.476 40.8093C181.188 48.4288 183.513 55.1442 186.741 60.6974C188.549 64.0551 190.745 67.4128 193.198 70.5123C189.195 66.8963 185.708 62.5054 182.609 57.7271C178.476 51.5282 175.506 43.7796 172.277 35.6436C171.244 32.9316 170.082 30.0904 168.92 27.2492C164.27 13.9475 152.906 5.94059 138.7 5.94059C138.442 5.94059 138.054 5.94059 137.796 5.94059C136.892 5.94059 135.859 5.81144 134.955 5.81144C120.62 5.81144 107.318 11.6229 100.215 21.1795C94.0164 29.0572 90.5295 39.0013 90.1421 50.6242C90.1421 51.9156 90.1421 53.0779 90.1421 54.2402V55.2733C90.0129 61.9888 91.0461 68.446 93.3706 74.5157Z",
    fill: "url(#paint12_radial_12_172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.697 5.0366C135.859 5.0366 136.892 5.0366 138.054 5.16574C147.74 5.29489 156.651 8.13604 162.462 12.7852C168.92 17.9509 172.019 24.5372 174.344 30.2196C175.764 33.8356 177.056 37.4516 178.218 40.8093C180.93 48.4288 183.254 55.1442 186.483 60.6974C187.904 63.2803 189.453 65.734 191.132 68.1877C188.033 64.9591 185.192 61.4722 182.738 57.4688C178.605 51.2699 175.635 43.5213 172.406 35.3853C171.373 32.6733 170.211 29.8321 169.049 26.991C164.399 13.5601 153.035 5.55317 138.7 5.55317C138.442 5.55317 138.054 5.55317 137.796 5.55317C136.892 5.55317 135.859 5.42403 134.955 5.42403C120.491 5.42403 107.189 11.3646 99.957 20.9212C93.6289 28.799 90.2712 38.743 89.8838 50.4951C89.8838 51.6573 89.8838 52.8196 89.8838 54.1111V54.4985V55.1442C89.7546 61.214 90.6586 67.1546 92.4666 72.8369C89.6255 68.446 86.2678 61.214 85.7512 50.7533C86.1386 40.2927 89.3672 30.8653 95.1786 22.9875C102.669 12.3978 118.554 5.0366 134.697 5.0366ZM134.697 4.64917C118.037 4.64917 102.152 12.2686 94.7912 22.9875C87.8175 32.415 85.622 42.359 85.2346 51.0116C85.8803 63.5385 90.6586 71.9329 94.0164 76.0654C92.0792 71.2871 90.0129 64.4425 90.2712 55.4025C90.2712 55.0151 90.2712 54.7568 90.2712 54.3694C90.2712 53.2071 90.1421 52.0448 90.2712 50.7533C90.5295 41.9716 92.7249 30.9944 100.215 21.4378C107.189 12.1395 120.232 5.9406 134.955 5.9406C135.859 5.9406 136.892 5.9406 137.796 6.06975C138.054 6.06975 138.442 6.06975 138.7 6.06975C154.843 6.06975 164.658 15.8846 168.661 27.2493C173.31 38.4847 176.926 49.4619 182.35 57.8562C186.483 64.3134 191.003 69.2208 195.136 72.5786C192.424 69.35 189.453 65.4757 186.87 60.5682C182.221 52.4322 179.38 41.9716 174.86 30.0904C172.406 24.279 169.307 17.6926 162.85 12.5269C156.393 7.36118 146.965 4.90746 138.183 4.77831C137.021 4.64917 135.859 4.64917 134.697 4.64917Z",
    fill: "url(#paint13_linear_12_172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3452 150.969L22.7292 139.991H24.2789L25.9578 145.415C26.4744 146.836 26.8618 148.257 27.1201 149.548C27.3784 148.257 27.895 146.836 28.4115 145.415L30.2195 139.991H31.7693L27.895 150.969H26.3452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9453 145.286C48.9453 149.031 46.6207 151.098 43.9087 151.098C40.9384 151.098 39.0013 148.773 39.0013 145.545C39.0013 142.058 41.1967 139.733 44.0379 139.733C47.0082 139.733 48.9453 142.058 48.9453 145.286ZM40.4219 145.545C40.4219 147.869 41.7133 150.065 43.9087 150.065C46.1042 150.065 47.3956 147.998 47.3956 145.545C47.3956 143.349 46.2333 141.025 43.9087 141.025C41.5842 140.895 40.4219 143.091 40.4219 145.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6311 139.991V150.969H57.2105V139.991H58.6311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2906 150.581C74.774 150.839 73.7409 151.098 72.4494 151.098C69.35 151.098 67.0254 149.161 67.0254 145.545C67.0254 142.058 69.35 139.733 72.7077 139.733C73.9991 139.733 74.9031 139.991 75.2906 140.25L74.9031 141.412C74.3866 141.154 73.6117 140.895 72.7077 140.895C70.1248 140.895 68.446 142.574 68.446 145.415C68.446 148.127 69.9957 149.806 72.7077 149.806C73.6117 149.806 74.5157 149.677 75.0323 149.29L75.2906 150.581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2381 145.803H84.9763V149.806H89.7546V150.969H83.5557V139.991H89.4963V141.154H84.9763V144.641H89.2381V145.803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.514 141.154H106.156V139.991H114.292V141.154H110.934V150.969H109.514V141.154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.951 145.286C130.951 149.031 128.627 151.098 125.915 151.098C122.944 151.098 121.007 148.773 121.007 145.545C121.007 142.058 123.203 139.733 126.044 139.733C129.014 139.733 130.951 142.058 130.951 145.286ZM122.428 145.545C122.428 147.869 123.719 150.065 125.915 150.065C128.11 150.065 129.402 147.998 129.402 145.545C129.402 143.349 128.239 141.025 125.915 141.025C123.59 140.895 122.428 143.091 122.428 145.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.581 139.991V150.969H149.161V139.991H150.581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.621 150.969V139.991H161.171L164.658 145.545C165.433 146.836 166.078 147.998 166.595 149.161C166.466 147.74 166.466 146.319 166.466 144.641V139.991H167.757V150.969H166.337L162.85 145.415C162.075 144.253 161.3 142.962 160.783 141.799C160.913 143.22 160.913 144.511 160.913 146.319V150.969H159.621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.797 139.991H182.738V141.154H178.218V144.77H182.35V145.932H178.218V150.839H176.797V139.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.682 139.991V150.969H191.261V139.991H192.682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.722 150.969V139.991H203.272L206.759 145.545C207.533 146.836 208.179 147.998 208.696 149.161C208.567 147.74 208.567 146.319 208.567 144.641V139.991H209.858V150.969H208.437L204.95 145.415C204.176 144.253 203.401 142.962 202.884 141.799C203.013 143.22 203.013 144.511 203.013 146.319V150.969H201.722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.319 139.991V150.969H218.898V139.991H220.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.425 141.154H228.067V139.991H236.203V141.154H232.845V150.969H231.425V141.154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.793 150.969V146.319L243.306 139.991H244.985L246.535 142.962C246.922 143.737 247.31 144.511 247.568 145.286C247.826 144.511 248.214 143.866 248.73 142.962L250.28 139.991H251.83L248.214 146.319V150.969H246.793Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_172",
    x1: 212.92,
    y1: 79.1332,
    x2: 212.953,
    y2: 66.2604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A9DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2314,
    stopColor: "#2A7DAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5015,
    stopColor: "#225184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    stopColor: "#1C376C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#15285F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13235B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_172",
    x1: 212.948,
    y1: 72.053,
    x2: 212.962,
    y2: 66.5354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12_172",
    x1: 212.917,
    y1: 78.9074,
    x2: 212.927,
    y2: 75.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9E9F",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#9C9E9F",
    stopOpacity: 0.0896252
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9E9F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12_172",
    x1: 103.862,
    y1: 79.1331,
    x2: 103.895,
    y2: 66.2604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97BF0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1065,
    stopColor: "#84B01C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5127,
    stopColor: "#42822D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8236,
    stopColor: "#046B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00632E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12_172",
    x1: 103.896,
    y1: 72.053,
    x2: 103.91,
    y2: 66.5354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12_172",
    x1: 103.865,
    y1: 78.9074,
    x2: 103.874,
    y2: 75.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9E9F",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#9C9E9F",
    stopOpacity: 0.0896252
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9E9F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12_172",
    x1: 109.945,
    y1: 51.2544,
    x2: 225.19,
    y2: 51.2544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97BF0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#679A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#3E802D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6083,
    stopColor: "#186F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8091,
    stopColor: "#00662F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00632E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12_172",
    x1: 161.403,
    y1: 51.2531,
    x2: 217.301,
    y2: 51.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0355776,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1818,
    stopColor: "#97BF0D",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4667,
    stopColor: "#97BF0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5073,
    stopColor: "#98BF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#9CC120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5324,
    stopColor: "#A1C431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5408,
    stopColor: "#A9C844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5481,
    stopColor: "#B3CD5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5545,
    stopColor: "#BFD474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5603,
    stopColor: "#CCDD92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5656,
    stopColor: "#DBE7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5706,
    stopColor: "#EBF2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#FCFDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5758,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6198,
    stopColor: "#F1F6E2",
    stopOpacity: 0.8963
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6992,
    stopColor: "#D9E5AE",
    stopOpacity: 0.7089
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7751,
    stopColor: "#C3D77D",
    stopOpacity: 0.5302
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8451,
    stopColor: "#B1CC56",
    stopOpacity: 0.3651
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    stopColor: "#A3C536",
    stopOpacity: 0.2166
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9618,
    stopColor: "#9BC01C",
    stopOpacity: 0.0899431
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BF0D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12_172",
    x1: 116.511,
    y1: 52.1473,
    x2: 225.148,
    y2: 52.1473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00632E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1909,
    stopColor: "#00662F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3917,
    stopColor: "#186F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#3E802D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    stopColor: "#679A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BF0D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_12_172",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.518 52.7937) scale(66.243 66.2431)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0727273,
    stopColor: "white",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820733,
    stopColor: "#EEF4DC",
    stopOpacity: 0.7804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0940653,
    stopColor: "#DAE6B0",
    stopOpacity: 0.7039
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1062,
    stopColor: "#C7D986",
    stopOpacity: 0.6265
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1182,
    stopColor: "#B7D062",
    stopOpacity: 0.5501
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#AAC845",
    stopOpacity: 0.4746
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1416,
    stopColor: "#A0C32D",
    stopOpacity: 0.4005
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1529,
    stopColor: "#99C018",
    stopOpacity: 0.3282
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1636,
    stopColor: "#97BF0D",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4667,
    stopColor: "#97BF0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5073,
    stopColor: "#98BF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#9CC120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5324,
    stopColor: "#A1C431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5408,
    stopColor: "#A9C844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5481,
    stopColor: "#B3CD5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5545,
    stopColor: "#BFD474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5603,
    stopColor: "#CCDD92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5656,
    stopColor: "#DBE7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5706,
    stopColor: "#EBF2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#FCFDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5758,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6198,
    stopColor: "#F1F6E2",
    stopOpacity: 0.8963
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6992,
    stopColor: "#D9E5AE",
    stopOpacity: 0.7089
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7751,
    stopColor: "#C3D77D",
    stopOpacity: 0.5302
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8451,
    stopColor: "#B1CC56",
    stopOpacity: 0.3651
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    stopColor: "#A3C536",
    stopOpacity: 0.2166
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9618,
    stopColor: "#9BC01C",
    stopOpacity: 0.0899431
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BF0D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_12_172",
    x1: 85.5329,
    y1: 39.8358,
    x2: 206.933,
    y2: 39.8358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B72B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2223,
    stopColor: "#1460A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6878,
    stopColor: "#183A73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13235B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12_172",
    x1: 85.3042,
    y1: 39.8427,
    x2: 207.196,
    y2: 39.8427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B72B5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1419,
    stopColor: "#1573B5",
    stopOpacity: 0.282
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2143,
    stopColor: "#2977B8",
    stopOpacity: 0.4259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#407EBC",
    stopOpacity: 0.5387
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3195,
    stopColor: "#5989C2",
    stopOpacity: 0.6352
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3629,
    stopColor: "#7599CB",
    stopOpacity: 0.7214
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4025,
    stopColor: "#94ACD6",
    stopOpacity: 0.8002
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4394,
    stopColor: "#B6C5E2",
    stopOpacity: 0.8734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#DAE1F0",
    stopOpacity: 0.9403
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5134,
    stopColor: "#ECF4FB",
    stopOpacity: 0.9724
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5325,
    stopColor: "#CDE3F4",
    stopOpacity: 0.9217
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5539,
    stopColor: "#AED3ED",
    stopOpacity: 0.8647
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5776,
    stopColor: "#91C6E8",
    stopOpacity: 0.8017
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6043,
    stopColor: "#76BBE3",
    stopOpacity: 0.7305
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6356,
    stopColor: "#5FB3E0",
    stopOpacity: 0.6473
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6742,
    stopColor: "#4BADDE",
    stopOpacity: 0.5445
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7284,
    stopColor: "#3DAADC",
    stopOpacity: 0.4003
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8788,
    stopColor: "#39A9DC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0D9F3",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_12_172",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.4 39.6775) scale(45.3249 45.3249)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B72B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    stopColor: "#1069AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2916,
    stopColor: "#175491"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#173770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7091,
    stopColor: "#13235B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_12_172",
    x1: 85.3507,
    y1: 40.279,
    x2: 195.222,
    y2: 40.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0D9F3",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1212,
    stopColor: "#39A9DC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3417,
    stopColor: "#A8D1EC",
    stopOpacity: 0.4665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5939,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6248,
    stopColor: "#E6E2EA",
    stopOpacity: 0.9241
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7312,
    stopColor: "#988DAC",
    stopOpacity: 0.6621
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8256,
    stopColor: "#605480",
    stopOpacity: 0.4294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9047,
    stopColor: "#3B3669",
    stopOpacity: 0.2348
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9652,
    stopColor: "#20285F",
    stopOpacity: 0.0857326
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13235B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 152.906,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoifinitywhite);
export default __webpack_public_path__ + "static/media/voifinity.white.ce17f584259d12b6f1305ea6cd3fde58.svg";
export { ForwardRef as ReactComponent };